import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaPhoneAlt } from 'react-icons/fa';
import logoSvg from '../assets/images/Shreeji Ambulance - Finaize.svg';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    // Scroll to top when menu item is clicked
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  };

  const isActive = (path) => location.pathname === path;

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <div className="header-content">
          <Link to="/" className="logo" onClick={closeMenu} aria-label="Shreeji Ambulance Home">
            <div className="logo-icon">
              <img
                src={logoSvg}
                alt="Shreeji Ambulance Logo"
                className="logo-image"
                width="100"
                height="85"
                loading="eager"
                decoding="async"
              />
            </div>
          </Link>

          <nav className={`nav ${isMenuOpen ? 'open' : ''}`}>
            <Link 
              to="/" 
              className={isActive('/') ? 'active' : ''} 
              onClick={closeMenu}
            >
              Home
            </Link>
            <Link 
              to="/about" 
              className={isActive('/about') ? 'active' : ''} 
              onClick={closeMenu}
            >
              About Us
            </Link>
            <Link 
              to="/services" 
              className={isActive('/services') ? 'active' : ''} 
              onClick={closeMenu}
            >
              Services
            </Link>
            <Link 
              to="/fleet" 
              className={isActive('/fleet') ? 'active' : ''} 
              onClick={closeMenu}
            >
              Fleet & Equipment
            </Link>
            <Link 
              to="/coverage" 
              className={isActive('/coverage') ? 'active' : ''} 
              onClick={closeMenu}
            >
              Coverage Area
            </Link>
            <Link 
              to="/contact" 
              className={isActive('/contact') ? 'active' : ''} 
              onClick={closeMenu}
            >
              Contact
            </Link>
            <a href="tel:+919825957225" className="nav-cta">
              <FaPhoneAlt /> Call Now
            </a>
          </nav>

          <button className="menu-toggle" onClick={toggleMenu} aria-label="Toggle menu">
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;


